<div id="crop-health-map-footer">
  <div class="map-color-spectrum-legend row mb-3">
    <div class="col-8">
      <div class="d-flex justify-content-between">
        <span class="spectrum-label">{{ 'doktar_app.common.lowest' | translate }}</span>
        <span class="spectrum-label">{{ 'doktar_app.common.highest' | translate }}</span>
      </div>
      <div class="bar gradient" [class.ndmi]="selectedMapType?.key === 'ndmi'"></div>
    </div>
    <div class="col-4">
      <div class="d-flex justify-content-between">
        <span class="spectrum-label">{{ 'doktar_app.common.cloud' | translate }}</span>
      </div>
      <div class="bar cloud"></div>
    </div>
  </div>

  @if (!loading) {
    <div id="map-type-option-btn" class="map-type-option-btn" (click)="showMapOptionsPanel = !showMapOptionsPanel">
      <div class="d-flex align-items-center gap-2">
        <span class="map-type-icon">
          @switch (selectedMapType?.value) {
            @case (0) {
              <dk-ndvi-map-icon />
            }
            @case (1) {
              <dk-ndmi-map-icon />
            }
            @case (2) {
              <dk-inspection-map-icon />
            }
            @case (3) {
              <dk-risk-map-icon />
            }
          }
        </span>
        <span class="label">{{ selectedMapType?.labelAbreviation | translate }}</span>
      </div>
      <i class="ph-bold ph-caret-down"></i>
    </div>
  }
</div>
@if (showMapOptionsPanel) {
  <div class="map-type-options-panel">
    <div class="map-type-options-panel-content">
      @for (mapType of cropHealthMapTypes; track mapType) {
        <div
          class="map-type-option-container"
          [class.selected]="selectedMapType?.key === mapType.key"
          (click)="mapSelectionPlaceEvent.emit('Map Selector'); cropHealthService.setSelectedMapType(mapType.key)">
          <div class="d-flex align-items-center gap-2">
            <span>
              @switch (mapType.key) {
                @case ('ndvi') {
                  <dk-ndvi-map-icon />
                }
                @case ('ndmi') {
                  <dk-ndmi-map-icon />
                }
                @case ('inspection') {
                  <dk-inspection-map-icon />
                }
                @case ('risk') {
                  <dk-risk-map-icon />
                }
              }
            </span>
            <p class="map-type-label">
              <span> {{ mapType.label | translate }} </span>
            </p>
          </div>
          <div>
            @if (selectedMapType?.key === mapType.key) {
              <i class="ph-fill ph-radio-button"></i>
            }
          </div>
        </div>
      }
      <p class="map-type-legend" (click)="openMapTypeLegend()">
        <i class="ph-fill ph-question-mark"></i>
        <span>{{ 'doktar_app.services.crop_monitoring.map_type_legend_question' | translate }}</span>
      </p>
    </div>
  </div>
}
